import React from 'react';
import { hasPermission } from '../../../lib/components/form/RestrictedComponent';

const MessageCenterHeaderNavigation = props => {
    const toggleMessageCenter = (event) => {
        if (event) event.preventDefault();
        // WorkspaceActions.toggleMessageCenter();
        props.toggleMessageCenter();
    }

    var badge = (props.totalUnread > 0) ?
        <span className="badge">{props.totalUnread}</span> :
        null
    ;

    let isMobileMode = (props.mode == 'mobile')

    let icon = <i title="messages" className="far fa-comments" aria-hidden="true"/>

    return (
        <li role="presentation" className={isMobileMode ? "isMobileMode menu-item hidden-sm hidden-md hidden-lg" : ""}>
            {
                hasPermission("account_messages.read") ? <a href="#" onClick={toggleMessageCenter} aria-selected="false">
                    {isMobileMode ? <span style={{padding: '0 1rem 0 0'}}>{icon}</span> : null}
                    <span className="header-nav-text">Messages {badge}</span>
                    {isMobileMode ? null : icon}
                </a> : null
            }
        </li>
    );
}

export default MessageCenterHeaderNavigation;
